export const SET_PLAN_VENTE = 'SET_PLAN_VENTE'
export const SELECT_PLAN_VENTE = 'SELECT_PLAN_VENTE'
export const RESET_PLAN_VENTE = 'RESET_PLAN_VENTE'
export const SET_SEARCH_STRING = 'SET_SEARCH_STRING'
